import { useMemo } from 'react';

import { BadgeBlock } from '../../../../types/Block';
import { BADGE_STATUS_TO_ICON_MAP } from '../../constants/badgeIcon';

export const useBadge = (block: BadgeBlock) => {
  const Icon = useMemo(
    () => BADGE_STATUS_TO_ICON_MAP[block.meta.status],
    [block.meta.status],
  );

  return {
    Icon,
  };
};
